//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class AddContactToCategoryCommand implements IAddContactToCategoryCommand {
    categoryId?: number;
    medewerkerId?: number;
    comment?: string | undefined;

    constructor(data?: IAddContactToCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.medewerkerId = _data["medewerkerId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddContactToCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddContactToCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["medewerkerId"] = this.medewerkerId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IAddContactToCategoryCommand {
    categoryId?: number;
    medewerkerId?: number;
    comment?: string | undefined;
}

export class AddContactToCategoryCommandResponse implements IAddContactToCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    contactPerson?: ContactPersonVm;

    constructor(data?: IAddContactToCategoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.categoryId = _data["categoryId"];
            this.contactPerson = _data["contactPerson"] ? ContactPersonVm.fromJS(_data["contactPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddContactToCategoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddContactToCategoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["categoryId"] = this.categoryId;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddContactToCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    contactPerson?: ContactPersonVm;
}

export class ConfirmFreeTrailCommand implements IConfirmFreeTrailCommand {
    hash?: string | undefined;
    verificationCode?: string | undefined;
    email?: string | undefined;

    constructor(data?: IConfirmFreeTrailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hash = _data["hash"];
            this.verificationCode = _data["verificationCode"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ConfirmFreeTrailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmFreeTrailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hash"] = this.hash;
        data["verificationCode"] = this.verificationCode;
        data["email"] = this.email;
        return data;
    }
}

export interface IConfirmFreeTrailCommand {
    hash?: string | undefined;
    verificationCode?: string | undefined;
    email?: string | undefined;
}

export class ConfirmFreeTrailCommandResponse implements IConfirmFreeTrailCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    email?: string | undefined;
    validated?: boolean;
    hash?: string | undefined;

    constructor(data?: IConfirmFreeTrailCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.email = _data["email"];
            this.validated = _data["validated"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): ConfirmFreeTrailCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmFreeTrailCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["email"] = this.email;
        data["validated"] = this.validated;
        data["hash"] = this.hash;
        return data;
    }
}

export interface IConfirmFreeTrailCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    email?: string | undefined;
    validated?: boolean;
    hash?: string | undefined;
}

export class ContactCategoryVm implements IContactCategoryVm {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IContactCategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ContactCategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IContactCategoryVm {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class ContactPersonVm implements IContactPersonVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    comment?: string | undefined;
    email?: string | undefined;
    available?: boolean;

    constructor(data?: IContactPersonVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pictureUrl = _data["pictureUrl"];
            this.comment = _data["comment"];
            this.email = _data["email"];
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): ContactPersonVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pictureUrl"] = this.pictureUrl;
        data["comment"] = this.comment;
        data["email"] = this.email;
        data["available"] = this.available;
        return data;
    }
}

export interface IContactPersonVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    comment?: string | undefined;
    email?: string | undefined;
    available?: boolean;
}

export class CreateContactPersonCategoryCommand implements ICreateContactPersonCategoryCommand {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateContactPersonCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateContactPersonCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactPersonCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateContactPersonCategoryCommand {
    name?: string | undefined;
    description?: string | undefined;
}

export class CreateContactPersonCategoryCommandResponse implements ICreateContactPersonCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    category?: ContactCategoryVm;

    constructor(data?: ICreateContactPersonCategoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? ContactCategoryVm.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateContactPersonCategoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactPersonCategoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateContactPersonCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    category?: ContactCategoryVm;
}

export class DeleteContactFromCategoryCommand implements IDeleteContactFromCategoryCommand {
    categoryId?: number;
    medewerkerId?: number;

    constructor(data?: IDeleteContactFromCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.medewerkerId = _data["medewerkerId"];
        }
    }

    static fromJS(data: any): DeleteContactFromCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteContactFromCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["medewerkerId"] = this.medewerkerId;
        return data;
    }
}

export interface IDeleteContactFromCategoryCommand {
    categoryId?: number;
    medewerkerId?: number;
}

export class DeleteContactFromCategoryCommandResponse implements IDeleteContactFromCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;

    constructor(data?: IDeleteContactFromCategoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteContactFromCategoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteContactFromCategoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        return data;
    }
}

export interface IDeleteContactFromCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
}

export class FreeTrailVm implements IFreeTrailVm {
    trailId?: string | undefined;
    trailName?: string | undefined;
    description?: string | undefined;
    emailRequired?: boolean;
    emailValidationRequired?: boolean;
    freeTrailCode?: string | undefined;

    constructor(data?: IFreeTrailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trailId = _data["trailId"];
            this.trailName = _data["trailName"];
            this.description = _data["description"];
            this.emailRequired = _data["emailRequired"];
            this.emailValidationRequired = _data["emailValidationRequired"];
            this.freeTrailCode = _data["freeTrailCode"];
        }
    }

    static fromJS(data: any): FreeTrailVm {
        data = typeof data === 'object' ? data : {};
        let result = new FreeTrailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trailId"] = this.trailId;
        data["trailName"] = this.trailName;
        data["description"] = this.description;
        data["emailRequired"] = this.emailRequired;
        data["emailValidationRequired"] = this.emailValidationRequired;
        data["freeTrailCode"] = this.freeTrailCode;
        return data;
    }
}

export interface IFreeTrailVm {
    trailId?: string | undefined;
    trailName?: string | undefined;
    description?: string | undefined;
    emailRequired?: boolean;
    emailValidationRequired?: boolean;
    freeTrailCode?: string | undefined;
}

export class MedewerkerVm implements IMedewerkerVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    email?: string | undefined;

    constructor(data?: IMedewerkerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pictureUrl = _data["pictureUrl"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MedewerkerVm {
        data = typeof data === 'object' ? data : {};
        let result = new MedewerkerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pictureUrl"] = this.pictureUrl;
        data["email"] = this.email;
        return data;
    }
}

export interface IMedewerkerVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    email?: string | undefined;
}

export class MyFreeTrailVm implements IMyFreeTrailVm {
    trailId?: number;

    constructor(data?: IMyFreeTrailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trailId = _data["trailId"];
        }
    }

    static fromJS(data: any): MyFreeTrailVm {
        data = typeof data === 'object' ? data : {};
        let result = new MyFreeTrailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trailId"] = this.trailId;
        return data;
    }
}

export interface IMyFreeTrailVm {
    trailId?: number;
}

export class NavigationGroup implements INavigationGroup {
    name?: string | undefined;
    items?: NavigationItem[] | undefined;

    constructor(data?: INavigationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NavigationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavigationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface INavigationGroup {
    name?: string | undefined;
    items?: NavigationItem[] | undefined;
}

export class NavigationItem implements INavigationItem {
    type?: string | undefined;
    id?: number;
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: INavigationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NavigationItem {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface INavigationItem {
    type?: string | undefined;
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
}

export class NavigationSeparator extends NavigationItem implements INavigationSeparator {

    constructor(data?: INavigationSeparator) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NavigationSeparator {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationSeparator();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INavigationSeparator extends INavigationItem {
}

export class NavigationUrl extends NavigationItem implements INavigationUrl {

    constructor(data?: INavigationUrl) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NavigationUrl {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationUrl();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INavigationUrl extends INavigationItem {
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RegisterForFreeTrailCommand implements IRegisterForFreeTrailCommand {
    trailId?: number;
    email?: string | undefined;
    forceSendValidationCode?: boolean;
    origin?: string | undefined;

    constructor(data?: IRegisterForFreeTrailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trailId = _data["trailId"];
            this.email = _data["email"];
            this.forceSendValidationCode = _data["forceSendValidationCode"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): RegisterForFreeTrailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterForFreeTrailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trailId"] = this.trailId;
        data["email"] = this.email;
        data["forceSendValidationCode"] = this.forceSendValidationCode;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IRegisterForFreeTrailCommand {
    trailId?: number;
    email?: string | undefined;
    forceSendValidationCode?: boolean;
    origin?: string | undefined;
}

export class RegisterForFreeTrailCommandResponse implements IRegisterForFreeTrailCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    needsVerification?: boolean;
    hash?: string | undefined;

    constructor(data?: IRegisterForFreeTrailCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.needsVerification = _data["needsVerification"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): RegisterForFreeTrailCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterForFreeTrailCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["needsVerification"] = this.needsVerification;
        data["hash"] = this.hash;
        return data;
    }
}

export interface IRegisterForFreeTrailCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    needsVerification?: boolean;
    hash?: string | undefined;
}

export class UpdateContactPersonCategoryCommand implements IUpdateContactPersonCategoryCommand {
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateContactPersonCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateContactPersonCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactPersonCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateContactPersonCategoryCommand {
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class UpdateContactPersonCategoryCommandResponse implements IUpdateContactPersonCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    category?: ContactCategoryVm;

    constructor(data?: IUpdateContactPersonCategoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? ContactCategoryVm.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateContactPersonCategoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactPersonCategoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateContactPersonCategoryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    validationErrors?: string[] | undefined;
    categoryId?: number;
    category?: ContactCategoryVm;
}

export class UserVm implements IUserVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    email?: string | undefined;
    highestRole?: string | undefined;

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pictureUrl = _data["pictureUrl"];
            this.email = _data["email"];
            this.highestRole = _data["highestRole"];
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pictureUrl"] = this.pictureUrl;
        data["email"] = this.email;
        data["highestRole"] = this.highestRole;
        return data;
    }
}

export interface IUserVm {
    id?: number;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    email?: string | undefined;
    highestRole?: string | undefined;
}